import { defineMessages } from 'react-intl';

export default defineMessages({
  CAROUSEL_ARIA_LABEL: {
    defaultMessage: "Carousel d'images",
  },

  CAROUSEL_ITEM_ARIA_LABEL: {
    defaultMessage: 'Slide {index, number} sur {total, number}',
  },
});
